<template>
  <li class="container-group-menu" :class="{'active':groupSelected}">

    <a href="#" @click="toggleGroupMenu()">
      <i class="metismenu-icon" :class="groupMenu.icon"></i>
      {{ groupMenu.name }}
      <i class="metismenu-state-icon pe-7s-angle-down caret-left"></i>
    </a>

    <transition name="slide-fade-menu-group" mode="out-in">

      <ul v-if="groupMenu.opened" class="menu-hidden-on-closed">

        <t-menu-group-item v-for="item in groupMenu.main" @pageRefresh="onPageRefresh" :key="item.pageId" :itemMenu="item"/>

<!--        <li class="item_menu menu-divisor" v-if="groupMenu.main.length > 0 && groupMenu.other.length > 0"></li>-->

        <t-menu-group-item v-for="item in groupMenu.other" @pageRefresh="onPageRefresh" :key="item.pageId" :itemMenu="item"/>

      </ul>

    </transition>
  </li>
</template>
<script>
import TMenuGroupItem from "@/components/template/menu/t-app-menu-group-item";

export default {
  name: "t-menu-group",
  components: {TMenuGroupItem},
  data() {
    return {
      opened:false,
    }
  },
  props: {
    groupMenu: {
      type: Object,
      required: true
    }
  },
  mounted(){
    this.opened = this.groupMenu.opened
  },
  methods: {
    toggleGroupMenu() {
      this.groupMenu.opened = !this.groupMenu.opened;
      this.$emit('onClickGroupMenu', this.groupMenu)
    },
    onPageRefresh(){
      /*Atualizar a página*/
      this.$emit('pageRefresh')
    }
  },
  computed: {

    groupSelected(){
      return this.groupMenu.pageModuleId === this.$store.getters.getCurrentPage.moduleId
    }

  }
}
</script>
<style scoped>
.menu-divisor {
  margin-top: 10px;
  margin-bottom: 10px;
  border-bottom: dotted 1px #BDBDBD;
  width: 65%;
  margin-left: 20%;
}
.closed-sidebar .app-sidebar:hover .menu-divisor {
  width: 70%;
  margin-left: 13%;
}
.slide-fade-menu-group-enter-active {
  transition: all .3s ease;
}

.slide-fade-menu-group-leave-active {
  transition: all .3s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}

.slide-fade-menu-group-enter, .slide-fade-menu-group-leave-to {
  transform: translateY(-20px);
  opacity: 0;
}
</style>
